import {
  Row, Col, Form, Select,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { STYLE } from 'src/constants';
import { roomIdsRule } from '../rules';

export const RoomIdsFormItem = () => {
  const { t } = useTranslation();

  return (
    <Row gutter={STYLE.BASE_MARGIN}>
      <Col xs={24}>
        <Form.Item
          label={t('Room IDs')}
          name="roomIds"
          rules={[roomIdsRule()]}
        >
          <Select
            mode="tags"
            tokenSeparators={[',', ' ']}
            notFoundContent={null}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};
